import { BluetoothService } from './BluetoothService';
import { IBluetoothService } from './IBluetoothService';
import { getConfig } from '../../config';
import { Logger } from '../../utils/Logger';

let bluetoothService: IBluetoothService | null = null;
export class BluetoothServiceSingleton {
  public static getBluetoothService(): IBluetoothService {
    if (!getConfig().allowBluetoothService) {
      Logger.leaveBreadcrumb('getBluetoothService, but allowBluetoothService is false');
      throw new Error('BluetoothService is disabled');
    }

    if (!bluetoothService) {
      bluetoothService = new BluetoothService();
    }
    return bluetoothService;
  }

  public static get hasInstanceBeenCreated(): boolean {
    return bluetoothService != null;
  }
}
